
(() => {
  const mobile = window.matchMedia('(max-width: 749px)');

  function syncFooters() {
    document.querySelectorAll('.fox-footer-toggle').forEach(button => {
      const content = document.getElementById(
        button.getAttribute('aria-controls')
      );

      if (!content) return;

      button.disabled = !mobile.matches;

      if (!mobile.matches) {
        content.hidden = false;
        button.setAttribute('aria-expanded', 'true');
      } else {
        content.hidden = true;
        button.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function init(root = document) {
    // Footer mobil
    root.querySelectorAll(
      '.footer__blocks-wrapper .footer-block--menu'
    ).forEach((block, index) => {
      const heading = block.querySelector('.footer-block__heading');

      if (!heading || heading.querySelector('button')) return;

      const children = Array.from(block.children).filter(
        element => element !== heading
      );

      if (!children.length) return;

      const content = document.createElement('div');
      content.className = 'fox-footer-content';

      content.id = `${
        block.closest('[id]')?.id || 'fox-footer'
      }-content-${index}`;

      children.forEach(child => content.append(child));
      block.append(content);

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'fox-footer-toggle';
      button.setAttribute('aria-controls', content.id);

      const label = document.createElement('span');
      label.textContent = heading.textContent;

      const plus = document.createElement('span');
      plus.textContent = ''; 
      plus.setAttribute('aria-hidden', 'true');

      button.append(label, plus);
      heading.replaceChildren(button);
    });

    syncFooters();
  }

  document.addEventListener('click', event => {
    // Navigare carusele FOXSUR
    const scrollButton = event.target.closest(
      '[data-fox-scroll]'
    );

    if (scrollButton) {
      const track = document.getElementById(
        scrollButton.getAttribute('aria-controls')
      );

      track?.scrollBy({
        left:
          Number(scrollButton.dataset.foxScroll) *
          track.clientWidth *
          0.9,

        behavior: window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
          ? 'auto'
          : 'smooth'
      });
    }

    // Deschidere / inchidere footer pe mobil
    const toggle = event.target.closest('.fox-footer-toggle');

    if (toggle && mobile.matches) {
      const expanded =
        toggle.getAttribute('aria-expanded') !== 'true';

      toggle.setAttribute(
        'aria-expanded',
        String(expanded)
      );

      const content = document.getElementById(
        toggle.getAttribute('aria-controls')
      );

      if (content) {
        content.hidden = !expanded;
      }
    }
  });

  document.addEventListener(
    'shopify:section:load',
    event => init(event.target)
  );

  mobile.addEventListener('change', syncFooters);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => init()
    );
  } else {
    init();
  }
})();
